@if(value) {
<p-accordion [multiple]="true">
  @for(item of keys; track $index) {
  <p-accordionTab [header]="item.key">
    <div class="tw-flex tw-flex-col tw-gap-2">
      @switch (item.type) {
      @default { <input [name]="item.key" [id]="item.key" pInputText [(ngModel)]="value[item.key]"
        (input)="onChange(value)" /> }
      @case ('text') {
      <textarea [name]="item.key" [id]="item.key" pInputTextarea [(ngModel)]="value[item.key]" (input)="onChange(value)"
        rows="3"></textarea>
      }
      @case ('html') {
      <textarea [name]="item.key" [id]="item.key" pInputTextarea [(ngModel)]="value[item.key]" (input)="onChange(value)"
        rows="7"></textarea>
      }
      @case ('json') {
      <textarea [name]="item.key" [id]="item.key" pInputTextarea [(ngModel)]="value[item.key]" (input)="onChange(value)"
        rows="7"></textarea>
      }
      @case ('checkbox') {
      <p-checkbox [name]="item.key" [inputId]="item.key" [ngModel]="value[item.key] === 'true'" [binary]="true"
        (onChange)="value[item.key] = $event.checked ? 'true' : 'false'; onChange(value)"></p-checkbox>
      }
      @case ('select') {
      <select [name]="item.key" [id]="item.key" [(ngModel)]="value[item.key]" (change)="onChange(value)"
        class="tw-w-full tw-rounded tw-border tw-border-gray-300 tw-bg-white tw-p-2">
        @for(option of item.data; track option) {
        <option [ngValue]="option">{{option}}</option>
        }
      </select>
      }
      @case ('file') {
      @if(value[item.key]){ <a [href]="value[item.key]" target="_blank" class="tw-mx-2">Download current <i
          class="pi pi-download"></i></a> }
      @if(!item._mode){
      <brt-file-upload [bucket]="fileBucket" [business-id]="businessId" [accept]="item.accept" mode="basic"
        (onUpload)="onUpload(item.key, $event)" chooseLabel="Choose file"></brt-file-upload>
      <a class="tw-cursor-pointer" (click)="item._mode='edit'">Edit link</a>
      }
      @else{
      <input [name]="item.key" [id]="item.key" pInputText [(ngModel)]="value[item.key]" (input)="onChange(value)" />
      <a class="tw-cursor-pointer" (click)="item._mode=null">Upload</a>}
      }
      @case ('image') {
      @if(value[item.key]){ <a [href]="value[item.key]" target="_blank"><img [src]="value[item.key]"
          class="tw-max-w-60" /></a> }
      @if(!item._mode){
      <brt-file-upload [bucket]="fileBucket" [business-id]="businessId" accept="image/*" mode="basic"
        (onUpload)="onUpload(item.key, $event)" chooseLabel="Choose image"></brt-file-upload>
      <a class="tw-cursor-pointer" (click)="item._mode='edit'">Edit link</a>
      }
      @else{
      <input [name]="item.key" [id]="item.key" pInputText [(ngModel)]="value[item.key]" (input)="onChange(value)" />
      <a class="tw-cursor-pointer" (click)="item._mode=null">Upload</a>}
      }
      }
      @if(item.data?.[0] == 'ai') {
      <button pButton type="button" icon="pi pi-sun {{item._busy?'pi-spin':''}}" label="Generate using AI"
        [disabled]="item._busy" (click)="requestAI(item)"></button>
      }
    </div>
  </p-accordionTab>
  }
</p-accordion>
}